/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';

/*Components*/


/*Assets*/

/*Services*/
import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';


class SignupTab1 extends Component {
  constructor(props){
    super(props);
    this.state = {
      type: null,
      apiLoading: true,
      selectedItem: null
    }
  }

  componentDidMount() {
    this.getTypes();
  }

  getTypes(){
    var url = devconfig.vendor+'sellertype/list';
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        this.setState({ type: response.data, apiLoading: false});
      }
      else {
        this.setState({apiLoading: false});
      }
    }.bind(this))
  }

  buttonClick(e){
    this.props.success(this.state.selectedItem)
  }

  render() {
    if(this.state.apiLoading){
      return(
        null
      )
    }
    return (
      <div className="col-10 mx-auto e-outer-wrap p-5">
        <div className="row">
          <div  className="col-lg-12">
            <h5>What type of seller are you?</h5>
          </div>
        </div>
        <div className="row pt-3">
          {
            this.state.type.map((item,index) => {
              return(
                <div className="col-md-6 mb-3">
                  <div className={this.state.selectedItem == item.id ? "e-outer-wrap e-seller e-online-seller e-active" : "e-outer-wrap e-seller e-online-seller"} onClick={(e) => {this.setState({selectedItem: item.id}) }}>
                    <span className="pl-4">{item.seller_type}</span>
                  </div>
                </div>
              );
            })
          }
        </div>
        
        <div className="row">
          <div className="col-lg-12 mt-3">
            {
              this.state.selectedItem ?
                <span className="e-signup-btn" onClick={this.buttonClick.bind(this)}>Next</span>
              :
                <span className="e-signup-btn e-in-active">Next</span>
            }
          </div>
        </div>

      </div>
    );
  }
}

export default SignupTab1;
